import {createLoaderWorker} from '@ptloader/loader-utils';
import {NullLoader} from '../null-loader';

createLoaderWorker(NullLoader);
